/** Amount charged online now; the rest is paid at the centre on the day. */
export const BOOKING_DEPOSIT_AMOUNT = 75;

export const bookingDepositFormatter = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export function formatBookingDeposit(amount: number = BOOKING_DEPOSIT_AMOUNT): string {
    return bookingDepositFormatter.format(amount);
}
